import type { ApolloContext } from '../../types';
import { updateActiveInbox, writeConversationFragment } from '../../util';
import { convertPubNubConversationToConversationItemFields } from './PubNubMessageReceived';

export const PubNubConversationRecovered = async (
  obj: any,
  args: { conversation: PubNubConversationModel },
  { client }: ApolloContext,
) => {
  const apolloConversation = convertPubNubConversationToConversationItemFields(
    args.conversation,
  );

  writeConversationFragment({
    client,
    conversation: apolloConversation,
    withLastAppointment: true,
    withLastChannel: false,
    withLastRepairOrder: true,
  });

  // Remove from Active conversations
  updateActiveInbox(client, [
    {
      id: args.conversation.id,
      inboxId: args.conversation.inbox_id,
      lastUpdated: args.conversation.last_updated,
      waitingSince: args.conversation.waiting_since,
      state: args.conversation.state,
      assigneeId: args.conversation.assignee && args.conversation.assignee.id,
      team: apolloConversation.team,
    },
  ]);
};
